exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5.red_text{line-height: 22px;}\n.check_in_out form .mat-dialog-content{height: 410px;}\n.outer_width{width: 600px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/edit-hotel-check-in-out/edit-hotel-check-in-out.component.css
// module id = ../../../../../src/app/admin/trip/edit-hotel-check-in-out/edit-hotel-check-in-out.component.css
// module chunks = 39